export class CalRuleDlyProg {
  id: number;
  calrule_id: number;
  daily_prog_id: number;
  dailyProgDescr: string;
  shift_select: boolean;
  reference_select: boolean
  selectWeekdays: number;
  weekDayDescr: string;
  isEdit: boolean;
}

export const CalRuleDlyProgColumns = [
  {
    key: 'daily_prog_id',
    type: 'select',
    required: true,
  },
  {
    key: 'dailyProgDescr',
    type: 'text',
    readonly: true
  },
  {
    key: 'shift_select',
    type: 'boolean'
  },
  {
    key: 'reference_select',
    type: 'boolean'
  },
  {
    key: 'selectWeekdays',
    type: 'select'
  },
  {
    key: 'weekDayDescr',
    type: 'text',
    readonly: true
  },
  {
    key: 'isEdit',
    type: 'isEdit',
    label: '',
  }
];


